import * as THREE from 'three';
import { ROOM } from './world';
import stories from '../../data/stories';

const FRAME_COLOR = 0x3a2e20;

function loadTexture(loader, url) {
  const tex = loader.load(url);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 4;
  return tex;
}

// 額縁つきの絵を作る（facing: 'z+' | 'z-' | 'x+'）
function makeFrame(loader, url, w, h, position, facing, { unlit = false } = {}) {
  const group = new THREE.Group();

  const frame = new THREE.Mesh(
    new THREE.BoxGeometry(w + 0.08, h + 0.08, 0.04),
    new THREE.MeshStandardMaterial({ color: FRAME_COLOR, roughness: 0.7 })
  );
  group.add(frame);

  const tex = loadTexture(loader, url);
  const picMat = unlit
    ? new THREE.MeshBasicMaterial({ map: tex })
    : new THREE.MeshStandardMaterial({ map: tex, roughness: 0.9 });
  const pic = new THREE.Mesh(new THREE.PlaneGeometry(w, h), picMat);
  pic.position.z = 0.025;
  group.add(pic);

  group.position.copy(position);
  if (facing === 'z-') group.rotation.y = Math.PI;
  if (facing === 'x+') group.rotation.y = Math.PI / 2;
  if (facing === 'x-') group.rotation.y = -Math.PI / 2;

  return group;
}

/**
 * 壁の額縁ギャラリー・ストーリーパネル・窓を配置する。
 * 返り値: ストーリーパネルのinteractable配列（近づくと物語が読める）
 */
export function createFrames(scene, loader) {
  const { width: W, depth: D } = ROOM;
  const interactables = [];

  // ── ストーリー3枚: 奥のアクセント壁（カウンター上）──
  const storyX = [-3.6, -1.5, 0.6];
  stories.forEach((story, i) => {
    const pos = new THREE.Vector3(storyX[i], 2.15, -D / 2 + 0.06);
    const group = makeFrame(loader, story.img, 1.15, 0.78, pos, 'z+');
    scene.add(group);
    interactables.push({
      id: `story-${story.id}`,
      type: 'panel',
      label: story.title,
      data: story,
      // 近接判定はカウンター越しになるので少し手前を基準点にする
      position: new THREE.Vector3(storyX[i], 1.5, -D / 2 + 1.6),
      setHighlight: () => {},
    });
  });

  // ── ギャラリー5枚: 入口側の壁 ──
  const gallery = [
    '/images/generated/gallery_01_tsurusenke.jpg',
    '/images/generated/gallery_02_korogi.jpg',
    '/images/generated/gallery_03_kutani_workshop.jpg',
    '/images/generated/gallery_04_natadera_autumn.jpg',
    '/images/generated/gallery_05_pour_coffee.jpg',
  ];
  const galleryX = [-4.6, -2.3, 0, 2.3, 4.6];
  gallery.forEach((url, i) => {
    const pos = new THREE.Vector3(galleryX[i], 1.85, D / 2 - 0.06);
    scene.add(makeFrame(loader, url, 1.05, 0.7, pos, 'z-'));
  });

  // ── 窓: 左壁に外の景色（南加賀の風景）──
  const windowPos = new THREE.Vector3(-W / 2 + 0.06, 1.7, 0.6);
  scene.add(
    makeFrame(loader, '/images/generated/slider_05_coffee_landscape.jpg', 3.2, 1.8, windowPos, 'x+', { unlit: true })
  );
  // 窓格子
  const barMat = new THREE.MeshStandardMaterial({ color: FRAME_COLOR, roughness: 0.7 });
  const vBar = new THREE.Mesh(new THREE.BoxGeometry(0.05, 1.8, 0.04), barMat);
  vBar.position.set(-W / 2 + 0.11, 1.7, 0.6);
  scene.add(vBar);
  const hBar = new THREE.Mesh(new THREE.BoxGeometry(0.05, 0.04, 3.2), barMat);
  hBar.position.set(-W / 2 + 0.11, 1.7, 0.6);
  scene.add(hBar);

  // ── 那谷寺インスパイア: 苔色ののれん的タペストリー（右壁の棚の両脇）──
  const clothMat = new THREE.MeshStandardMaterial({ color: 0x1a3a2a, roughness: 1 });
  [-3.2, 3.2].forEach((z) => {
    const cloth = new THREE.Mesh(new THREE.PlaneGeometry(0.7, 2.0), clothMat);
    cloth.position.set(W / 2 - 0.08, 1.9, z);
    cloth.rotation.y = -Math.PI / 2;
    scene.add(cloth);
  });

  return interactables;
}
